<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div class="p-3">
            <h5>Offerings Table</h5>

            <h2 class="main-title">
              {{ content.title }}

            </h2>
            <p class="text-muted m-0 text-right">As of {{ FormatDateTime(content.date) }}</p>
            <div class="row">
              <div class="col-lg-8 col-md-8 col-12"></div>
            </div>
            <div class="table-responsive mt-3">
              <sorted-table
                :values="content.offeringsTable"
                class="table secondary-table table-bordered text-nowrap"
              >
                <thead>
                  <tr>
                    <th scope="col" class="text-center">
                      <sort-link name="status">Status</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="symbol">Stock Symbol</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="company">Company</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="type">Type</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="entitlementRatio">Entitlement Ratio</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="price">Price (PHP)</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="exRights">Ex-Rights</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="payment">Payment</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="priceSettingDate">Price Setting Date</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="offerPeriod">Offer Period</sort-link>
                    </th>

                    <th scope="col" class="text-center">
                      <sort-link name="targetListingDate">Target Listing Date</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="primaryShares">Primary Shares</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="secondaryShares">Secondary Shares</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="overAllotmentOption"
                        >Over-allotment Option</sort-link
                      >
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="totalOfferedSharesPlusOverAllotmentOption"
                        >Total Offered  Shares Plus Over-allotment Option</sort-link
                      >
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="targetDelistingDate"
                        >Target Delisting Date</sort-link
                      >
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="prospectus">Prospectus *</sort-link>
                    </th>
                  </tr>
                </thead>
                <template #body="sort">
                  <tbody>
                    <tr v-for="(item, index) in sort.values" :key="index">
                      <td class="text-left">{{ item.status }}</td>
                      <td class="text-left">
                        <b>{{ item.symbol }}</b>
                      </td>
                      <td class="text-left">{{ item.company }}</td>
                      <td class="text-right">{{ item.type }}</td>
                      <td class="text-right">{{ item.entitlementRatio }}</td>
                      <td class="text-right">{{ item.price}}</td>
                      <td class="text-right">{{ item.exRights }}</td>
                      <td class="text-right">{{ item.payment }}</td>
                      <td class="text-right">{{ item.priceSettingDate }}</td>
                      <td class="text-right">{{ item.offerPeriod }}</td>
                      <td class="text-right">{{ item.targetListingDate }}</td>
                      <td class="text-right">{{ item.primaryShares }}</td>
                      <td class="text-right">{{ item.secondaryShares }}</td>
                      <td class="text-right">{{ item.overAllotmentOption }}</td>
                      <td class="text-left">
                        {{ item.totalOfferedSharesPlusOverAllotmentOption }}
                      </td>
                      <td class="text-right">{{ item.targetDelistingDate }}</td>
                      <td class="text-center">
                        <a target="_blank" :href="item.prospectus"
                          ><i class="bi bi-filetype-pdf"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </sorted-table>
             <div v-if="content.offeringsTable.length == 0">
                   <Noresult/>
              </div> 

              <b-skeleton-table
                :rows="19"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
                v-if="isDataLoaded"
              ></b-skeleton-table>
            </div>

            <h5 class="sub-title-page">{{ content.articleLabel }}</h5>

            <div v-for="(item, index) in content.templates" :key="index">
              <div v-if="item.contentType == 'string'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>

              <div v-if="item.contentType == 'date'">
                <p class="text-muted" v-html="FormatDate(item.content)"></p>
              </div>

              <div v-if="item.contentType == 'image'" class="image-umbraco">
                <b-img
                  class="img-thumbnail"
                  :src="'data:image/jpeg;base64,' + item.content"
                  fluid-grow
                  alt="Fluid-grow image"
                ></b-img>
              </div>
              <div class="table table-umbraco" v-if="item.contentType == 'table'">
                <p v-html="item.content"></p>
              </div>
               <bullMeter
                  :slider="ConvertValue(item.content)"
                  v-if="item.contentType == 'slider'"
                />
           
              <div v-if="item.contentType == 'link'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>
            </div>

            <a href="javascript:void(0)" @click="ViewArchive()">
              View Offerings Table Archive
            </a>

            <h4 class="main-title mt-5">Legends</h4>
            <div class="row mb-5">
              <div class="col-lg-6 col-md-6 col-12">
                <ul style="list-style-type: circle">
                  <li>SRO - Stock Rights Offering</li>
                  <li>IPO - Initial Public Offering</li>
                  <li>FOO - Follow-on Offering</li>
                </ul>
              </div>
            </div>
            <Disclaimer />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader";
import Disclaimer from "../ReportsPages/Disclaimer";
import bullMeter from "../BullMeter/BullMeter.vue";
import Noresult from "../NoResult.vue";
import { mapState } from "vuex";
import Footer from "../Footer";
import moment from "moment";
export default {
  components: {
    Disclaimer,
    navHeader,
    Footer,
    bullMeter,
    Noresult,
  },

  data() {
    return { isDataLoaded: false, values: [] };
  },
  computed: {
    ...mapState({
      content: (state) => state.philstocksResearch.offeringsTableContent,
    }),
  },
  methods: {
    GoogleAnalytics() {
      this.$gtag.event("OfferingsTable", { method: "Google" });
    },
    FormatPrices(data) {
      var price = parseFloat(data);

      if (price == 0) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price < 0.51) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        });
      } else if (price >= 1000) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price == undefined || isNaN(price)) {
        return 0;
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    ViewArchive() {
      this.$router.push("/Reports/Archive/OfferingsTable");
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
     FormatDateTime(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("LL");
      }
      return result;
    },

   ConvertValue(data) {
      var value = parseInt(data);
     return value;
    },

    async GetOfferingsTableContent(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetOfferingsTable", data)
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },
  async mounted() {
    this.GetOfferingsTableContent(this.$route.query.date);
  },
};
</script>

<style></style>
